import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useLead } from '../../../hooks/Features/useLeads'
import { itemsPerPage } from '../../../shared/data'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { NoDataFound } from '../../NoDataFound'

export default function TSMDetailedReportMTD() {
  const { loading, getTSMDetailedReportMTD, lead } = useLead()
  const [page, setPage] = useState(1)
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())
  const [filterParams, setFilterParams] = useState({})

  useEffect(() => {
    setPage(1)
    getTSMDetailedReportMTD({ from, to, ...filterParams })
  }, [from, to, filterParams])

  const noOfPages = Math.ceil(lead && lead.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const heading = [
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'City', key: 'city' },
    { label: 'TSM Name', key: 'tsmName' },
    { label: 'Qty', key: 'qty' },
    { label: 'Value', key: 'value' },
  ]

  let tempLead = []
  lead &&
    lead.forEach((item) =>
      tempLead.push({
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        tsmName: item.rank5Name,
        qty: item.quantity,
        value: item.value
      })
    )

  return (
    <Layout
      heading="TSM Detailed Report MTD"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempLead ? tempLead : []}
      tempHeaderData={[]}
      filename='tsm_detailed_report_mtd'
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          headingOnClick={{
            'QTY': () => {
              setFilterParams({ ...filterParams, value: null, quantity: filterParams.quantity === 1 ? -1 : 1 })
            },
            'VALUE': () => {
              setFilterParams({ ...filterParams, quantity: null, value: filterParams.value === 1 ? -1 : 1 })
            },
          }}
          heading={['REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'TSM Name', 'QTY', 'VALUE']}
        />
        <TableBody className={styles.tr}>
          {!loading &&
            lead.length > 0 &&
            lead.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.region ? item.region.name : '-----'} </TableCell>
                  <TableCell> {item.zone ? item.zone.name : '-----'} </TableCell>
                  <TableCell> {item.state ? item.state.name : '-----'} </TableCell>
                  <TableCell> {item.district ? item.district.name : '-----'} </TableCell>
                  <TableCell> {item.city ? item.city.name : '-----'} </TableCell>
                  <TableCell> {item.rank5Name} </TableCell>
                  <TableCell> {item.quantity} </TableCell>
                  <TableCell> {item.value} </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && lead.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {!loading && lead.length === 0 && <NoDataFound />}
    </Layout>
  )
}
